import React, { useEffect, useContext, useState, useRef } from "react";
import * as Yup from "yup";
// import "../Css/Login.css";
import { Formik } from "formik";
import {
  GetBasicData,
  HeaderFooterContext,
  SetHistory,
  HeaderContext,
  SignInStatusContext,
} from "../Basic/BasicData";
import { api } from "../Basic/ApiFetch";
import CacheLoader from "../Basic/CacheLoader";
import { useTranslation } from 'react-i18next';
import { IsNullOrEmpty, openPage } from "../Basic/SDOExtension";
import TextInput from "../Components/Input/TextInput";
import { Captcha } from "../Components/Captcha/Captcha";
import { getCaptchaService } from "src/HomePage/CaptCha.service";
import {
  showGlobalMessageBox,
  getGlobalServerConfig,
  resetGlobalServerConfig,
} from "../Route/RootMiddleware";
import { WindowResizehook } from "../Hook/useWindowResize";

import { Button } from "@progress/kendo-react-buttons";
import { Window } from "@progress/kendo-react-dialogs";

import logoLogin from "../Images/logo_login.png";
import iconUnlock from "../Images/fa-unlock-alt.png";
import iconQuestion from "../Images/icon_question_h.png";

import ResetPW from "./ResetPW";
import ForgotPW from "./ForgotPw/ForgotPW";
import { GetScLink, GetSingleSetParam } from "../Basic/CommonService";

const LoginPanel = ({ goConfirmPersonalInformation, goforgotPW, ...props }) => {
  const initCaptchaEncode = { CaptchaEncode: "" };
  const { setSignInStatus, signInStatus } = useContext(SignInStatusContext);
  const { headerFooterStatus, setHeaderFooterStatus } =
    React.useContext(HeaderFooterContext);
  const [passwordVisible, setPasswordVisible] = useState(true);
  const [captchaTxt, setCaptcha] = useState(initCaptchaEncode);
  const [tempData, setTempData] = useState({});
  const loginCnt = useRef(0);
  const { t } = useTranslation();

  const dimensions = WindowResizehook();

  const isLoad = useRef(false);
  useEffect(() => {

    if (!isLoad.current) {
      cacheLoaderCheck()
      // 紀錄目前登入狀態
      setSignInStatus()
      getCaptcha()
    }
    isLoad.current = true;
  }, []);

  /**
   * 清除快取
   */
  const cleanCache = async () => {
    if (!IsNullOrEmpty(await CacheLoader().GetCache())) {
      // 清除快取
      await CacheLoader().DeleteCache();
    }
    // 紀錄目前登入狀態
    setSignInStatus();
  };

  /**
   * 檢查快取，若存在直接進行導頁
   */
  const cacheLoaderCheck = async () => {
    SetHistory(props.history);
    let cacheLoader = CacheLoader();
    let loadResult = await cacheLoader.LoadCache();
    if (loadResult) {
      setSignInStatus();
      //props.history.push('/SystemSelector');
      props.history.push("/Home");
    } else if (loginCnt.current === 0) {
      loginCheck(tempData);
      loginCnt.current = loginCnt.current + 1;
    } else {
      console.log("LoginError");
    }
  };

  //登入驗證
  const loginCheck = async (data) => {

    if (IsNullOrEmpty(data.USER_PD) || IsNullOrEmpty(data.Captcha)) return;

    const encoder = new TextEncoder();
    let passData = { ...data };
    const textEncoder = new TextEncoder();
    const userPD = textEncoder.encode(passData.USER_PD);
    passData.USER_PD = btoa(String.fromCharCode(...new Uint8Array(userPD)));
    setTempData(passData);

    passData.CaptchaEncoded = captchaTxt.CaptchaEncode;
    let url = getGlobalServerConfig().backEndUrl.get() + "Login";
    let response = await api.Post(url, JSON.stringify(passData));
    if (response.ok) {
      let result = await response.json();
      if (!result.rtnModel.success) {
        showGlobalMessageBox(result.rtnModel.message);
        return;
      }

      setSignInStatus()
      props.history.push('/Home');
    }
  };

  //取得驗證碼
  const getCaptcha = async (e) => {
    if (e) e.preventDefault();
    const captchaData = await getCaptchaService();
    if (captchaData) {
      setCaptcha(captchaData);
    }
  };

  //欄位驗證
  const validateField = Yup.object().shape({
    USER_ID: Yup.string().required(t('moea_ic.logInPage.enterAccount')),
    USER_PD: Yup.string().required(t('moea_ic.logInPage.enterPassword')),
    Captcha: Yup.string().required(t('moea_ic.logInPage.enterCode'))
  });

  // 連結SC網址
  const onClickScLink = async (dominName, apId) => {
    let url =
      getGlobalServerConfig().backEndUrl.get() +
      "Login/GetScLink/" +
      dominName +
      "/" +
      apId;
    let response = await api.Get(url, null, new Headers(), false);
    let data = {};
    if (response.ok) {
      data = await response.json();
    }

    let link = data.message.replaceAll("&amp;", "&");
    openPage(link, `${dominName}_${apId}`);
  };

  return (
    <div className="login_content_right_box_width">
      <div className="login_box">
        <Formik
          initialValues={{
            USER_ID: "",
            USER_PD: "",
            Captcha: "",
            CaptchaEncoded: "",
          }}
          validationSchema={validateField}
          onSubmit={(data) => loginCheck(data)}
        >
          {(props) => {
            const {
              values,
              errors,
              handleBlur,
              handleSubmit,
              handleChange,
              submitForm,
            } = props;
            return (
              <form onSubmit={handleSubmit}>
                <div className="login_box_header">
                  <div className="login_box_headline me-auto">{t('moea_ic.logInPage.logIn')}</div>
                  <div className="login_box_btn" onClick={() => goConfirmPersonalInformation()}>{t('moea_ic.logInPage.register')}</div>
                </div>
                <div className="login_box_input">
                  <div className="login_box_txt">{t('moea_ic.logInPage.account')}</div>
                  <TextInput
                    onChange={handleChange}
                    value={values.USER_ID}
                    name="USER_ID"
                    onBlur={handleBlur}
                    error={errors.USER_ID}
                    onKeyDown={(e) => {
                      if (e.key === "enter") {
                        submitForm();
                      }
                    }}
                    className="form-control"
                    placeholder={t('moea_ic.logInPage.enterAccount')}
                  />
                  <div className="margin_t30"></div>
                  <div className="login_box_txt">{t('moea_ic.logInPage.password')}</div>
                  <div style={{ overflow: "hidden", display: "flex" }}>
                    
                    <div style={{ float: "left", width: "93%" }}>
                      <TextInput
                        onChange={handleChange}
                        value={values.USER_PD}
                        name="USER_PD"
                        type={passwordVisible ? "password" : "text"}
                        onBlur={handleBlur}
                        error={errors.USER_PD}
                        onKeyDown={(e) => {
                          if (e.key === "enter") {
                            submitForm();
                          }
                        }}
                        // className="form-control"
                        placeholder={t('moea_ic.logInPage.enterPassword')}
                      />
                    </div>
                    <i
                      className={`fa ${passwordVisible ? "fa-eye" : "fa-eye-slash"} pull-right`}
                      onClick={() => setPasswordVisible(!passwordVisible)}
                      style={{ marginTop: "5px",float: "right", cursor: "pointer",fontSize:"25px" }}
                    ></i>
                  </div>
                  <div className="login_box_rightlink">
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault();
                        goforgotPW();
                      }}
                      style={{ color: "#00A698" }}
                    >
                      <span>{t('moea_ic.logInPage.forgot')}</span>
                    </a>
                  </div>
                </div>
                <div className="login_box_txt">{t('moea_ic.logInPage.verifyCode')}</div>

                <div className="flex">
                  <div className="me-lg-auto-width">
                    <TextInput
                      onChange={handleChange}
                      value={values.Captcha}
                      name="Captcha"
                      onBlur={handleBlur}
                      error={errors.Captcha}
                      className="form-control"
                      placeholder={t('moea_ic.logInPage.enterCode')}
                    />
                  </div>
                  <div className="flex_center">
                    <div className="margin_xl10">
                      {captchaTxt.Img && (
                        <Captcha
                          Img={captchaTxt.Img}
                          GetCaptcha={getCaptcha}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="margin_t30"></div>

                <button type="submit" className="blue_common_button" >{t('moea_ic.logInPage.logIn')}</button>
              </form>
            );
          }}
        </Formik>
      </div>
    </div >
  );
};

export default LoginPanel;
